/** Compatibility slot for older layouts. The product interface is English-only. */
export interface LanguageToggleProps {
  readonly className?: string;
}

export function LanguageToggle(_props: LanguageToggleProps) {
  return null;
}
